// HtmlEntities.jsx
import React from "react";

const HtmlEntities = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h1>HTML Entities - Comprehensive Notes</h1>

      {/* Introduction */}
      <section id="introduction">
        <h2>1. Introduction to HTML Entities</h2>
        <p>
          HTML entities are special codes used to display reserved characters, symbols,
          or characters not easily typed on a keyboard. They prevent browsers from
          misinterpreting content as HTML code.
        </p>
        <ul>
          <li>Display reserved HTML characters (&lt;, &gt;, &amp;) safely.</li>
          <li>Show special symbols, accents, or non-English characters.</li>
          <li>Ensure consistent display across browsers and devices.</li>
        </ul>
      </section>

      {/* Basic Character Entities */}
      <section id="basic-entities">
        <h2>2. Basic Character Entities</h2>
        <table border="1" cellPadding="5">
          <thead>
            <tr>
              <th>Character</th>
              <th>Entity Name</th>
              <th>Entity Number</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>&amp;</td><td>&amp;amp;</td><td>&#38;</td></tr>
            <tr><td>&lt;</td><td>&amp;lt;</td><td>&#60;</td></tr>
            <tr><td>&gt;</td><td>&amp;gt;</td><td>&#62;</td></tr>
            <tr><td>"</td><td>&amp;quot;</td><td>&#34;</td></tr>
            <tr><td>'</td><td>&amp;apos;</td><td>&#39;</td></tr>
          </tbody>
        </table>
        <p>Example:</p>
        <p>{`5 < 10 & 10 > 5`}</p>
        <p>{`He said, "Hello!"`}</p>
      </section>

      {/* Accented Characters */}
      <section id="accents">
        <h2>3. Accented Characters</h2>
        <p>Examples:</p>
        <p>Cr&egrave;me br&ucirc;l&eacute;e</p>
        <p>Jos&eacute; Mar&iacute;a</p>
        <p>Na&iuml;ve approach</p>
      </section>

      {/* Mathematical Symbols */}
      <section id="math-symbols">
        <h2>4. Mathematical Symbols</h2>
        <p>Examples:</p>
        <p>5 &times; 6 = 30</p>
        <p>10 &le; 15 &amp; 20 &ge; 10</p>
      </section>

      {/* Currency Symbols */}
      <section id="currency">
        <h2>5. Currency Symbols</h2>
        <p>Price: &dollar;50, &euro;40, &pound;35, &yen;5000</p>
      </section>

      {/* Arrows */}
      <section id="arrows">
        <h2>6. Arrows & Directional Symbols</h2>
        <p>Navigate: &larr; Back &rarr; Forward</p>
      </section>

      {/* Fractions */}
      <section id="fractions">
        <h2>7. Fractions</h2>
        <p>Recipe: 1 &frac12; cups of milk</p>
      </section>

      {/* Legal Symbols */}
      <section id="legal-symbols">
        <h2>8. Special & Legal Symbols</h2>
        <p>&copy; 2024 MyWebsite. All rights reserved.</p>
        <p>Product is a registered trademark &reg;</p>
      </section>

      {/* Emoji */}
      <section id="emoji">
        <h2>9. Emoji & Miscellaneous Symbols</h2>
        <p>Emoji: &#x1F600; &#x1F44D; &#x1F4BB;</p>
        <p>Card suits: &hearts; &diams; &spades; &clubs;</p>
      </section>

      {/* Best Practices */}
      <section id="best-practices">
        <h2>10. Best Practices</h2>
        <ul>
          <li>Prefer named entities (&amp;amp;) for readability; use numeric codes for rare symbols.</li>
          <li>Always escape reserved HTML characters (&lt;, &gt;, &amp;).</li>
          <li>Ensure UTF-8 encoding for consistent display of special characters.</li>
          <li>Use HTML entities for non-keyboard characters instead of copying/pasting them.</li>
        </ul>
      </section>
    </div>
  );
};

export default HtmlEntities;
